import { SharedModule } from '../app-shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { OAuthModule, AuthConfig  } from 'angular-oauth2-oidc';
import { LoginGoogleComponent } from './login-google.component';



const routes: Routes = [
  {
    path: '', component: LoginGoogleComponent
  }]

@NgModule({
  declarations: [LoginGoogleComponent],
  imports: [
    CommonModule,
    SharedModule,
    // OAuthModule.forRoot(),
    RouterModule.forChild(routes)
  ],
  exports: [LoginGoogleComponent]
})
export class LoginGoogleModule { }
